import { isNative } from '../../native/native'
import { onNotificationTap } from '../../native/nativePush'
import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router'
import { ConversationList } from '../conversations/ConversationList'
import { NewChannelDialog } from '../channels/NewChannelDialog'
import { NewGroupDialog } from '../channels/NewGroupDialog'
import { NewDmDialog } from '../channels/NewDmDialog'
import { BotProfileDialog } from '../bots/BotProfileDialog'
import { PushPrompt } from './PushPrompt'
import { TabBar } from './TabBar'
import { coversTabBar } from './sections'
import { useClearNotificationsWhenOpen } from '../../push/clearNotifications'
import { useAppBadge } from './useAppBadge'
import { useEdgeSwipeBack } from './useEdgeSwipeBack'

/** Two panes on desktop; on mobile (< 768px) the list and the detail are separate screens. */
export function AppShell() {
  const location = useLocation()
  const navigate = useNavigate()
  const detail = location.pathname !== '/'
  const inConversation = coversTabBar(location.pathname)
  const edgeBack = useEdgeSwipeBack()
  useAppBadge()
  useClearNotificationsWhenOpen()

  // Notification clicks while the app is open arrive as a message from the service worker.
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return
    const onMessage = (event: MessageEvent) => {
      const data = event.data as { type?: string; url?: string } | null
      if (data?.type === 'NAVIGATE' && typeof data.url === 'string' && data.url.startsWith('/')) navigate(data.url)
    }
    navigator.serviceWorker.addEventListener('message', onMessage)
    return () => navigator.serviceWorker.removeEventListener('message', onMessage)
  }, [navigate])

  // In the app, a tapped notification (including the one that started it) opens its conversation.
  useEffect(() => (isNative() ? onNotificationTap((url) => navigate(url)) : undefined), [navigate])

  return (
    <div className={['app', detail ? 'mobile-detail' : '', inConversation ? 'in-conversation' : ''].filter(Boolean).join(' ')}>
      <main className="main-workspace">
        <div className="messaging">
          <ConversationList />
          <section className="chat" aria-label="Active conversation" ref={edgeBack.paneRef} {...edgeBack.handlers}>
            <Outlet />
          </section>
        </div>
      </main>
      <TabBar />
      <NewChannelDialog />
      <NewGroupDialog />
      <NewDmDialog />
      <BotProfileDialog />
      <PushPrompt />
    </div>
  )
}
